import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.login-with-domain', {
        url: '/login/:domain?code',
        component: 'login',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/public/domain-login/domain-login.state.js